let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("75E1q")).then(() => parcelRequire('hGttD'));